const options = {
  5: "bg-purple-400/5",
  10: "bg-purple-400/10",
  25: "bg-purple-400/25",
  50: "bg-purple-400/50",
  75: "bg-purple-400/75",
  90: "bg-purple-400/90",
  100: "bg-purple-400",
};

const from = {
  5: "from-purple-400/5",
  10: "from-purple-400/10",
  25: "from-purple-400/25",
  50: "from-purple-400/50",
  75: "from-purple-400/75",
  90: "from-purple-400/90",
  100: "from-purple-400",
};

export default function getBackgroundPurple400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
